import { message } from "antd";
import { cmmsPost, fechaDiaPayload } from "../cmmsComun";

// Llamadas sobre renglones del programa (PlanServicioCMMS) que comparten la agenda, la
// calendarizacion del contrato y el detalle de un plan. Devuelven true si se aplico.

const avisar = (res, exito) => {
    if (res.data.success !== 2) {
        message.error(res.data.message || "No se pudo guardar");
        return false;
    }
    const { actualizados, omitidos, motivosOmitidos } = res.data;
    if (omitidos) message.warning(`${exito(actualizados)} · ${omitidos} no se cambiaron${motivosOmitidos?.length ? ` (${motivosOmitidos.join(", ")})` : ""}`);
    else message.success(exito(actualizados));
    return true;
};

// datos: { fecha: moment|null, quitarFecha, cambiarEmpleado, empleadoId }
export const calendarizarPlanes = async (props, ids, datos) => {
    const res = await cmmsPost(props, "calendarizarPlanesCMMS", {
        ids,
        fechaPlaneada: fechaDiaPayload(datos.fecha),
        quitarFecha: !!datos.quitarFecha,
        cambiarEmpleado: !!datos.cambiarEmpleado,
        empleadoId: datos.empleadoId || null,
    });
    return avisar(res, (n) => (datos.quitarFecha ? `Se quitó la fecha a ${n}` : `${n ?? ids.length} calendarizado(s)`));
};

export const noRealizarPlanes = async (props, ids, motivo) => {
    const res = await cmmsPost(props, "noRealizarPlanesCMMS", { ids, motivo });
    return avisar(res, (n) => `${n} marcado(s) como no realizado`);
};

export const reactivarPlanes = async (props, ids) => {
    const res = await cmmsPost(props, "reactivarPlanesCMMS", { ids });
    return avisar(res, (n) => `${n} reactivado(s)`);
};

export const editarPlan = async (props, id, cambios) => {
    const res = await cmmsPost(props, "editarPlanCMMS", { id, ...cambios });
    if (res.data.success !== 2) {
        message.error(res.data.message || "No se pudo guardar");
        return false;
    }
    return true;
};

export const eliminarPlan = async (props, id) => {
    const res = await cmmsPost(props, "eliminarPlanCMMS", { id });
    if (res.data.success !== 2) {
        message.error(res.data.message || "No se pudo quitar");
        return false;
    }
    message.success("Se quitó de la agenda");
    return true;
};

// Listas de Configuracion que usan estas pantallas.
export const cargarListasCMMS = async (props) => {
    try {
        const res = await cmmsPost(props, "datosConfiguracionCMMS");
        return res.data.success === 2 ? res.data.configuracion : {};
    } catch (error) {
        console.log(error);
        return {};
    }
};
